import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Tooltip from '../Tooltip';

class MenuItem extends React.Component {
  state = {
    isTooltipActive: false,
  }

  showTooltip = () => {
    this.setState({ isTooltipActive: true });
  }

  hideTooltip = () => {
    this.setState({ isTooltipActive: false });
  }

  iamme = (element) => {
    this.element = element;
  }

  render() {
    const {
      active,
      data,
      inverse,
      onClick,
    } = this.props;
    const { isTooltipActive } = this.state;
    const {
      description,
      icon,
      image,
      name,
    } = data;

    const tooltipData = {
      image,
      name,
      description,
    };

    return (
      <li className="nav__item">
        <button
          onClick={onClick.bind(this, name)}
          ref={this.iamme}
          onBlur={this.hideTooltip}
          onFocus={this.showTooltip}
          onMouseOver={this.showTooltip}
          onMouseOut={this.hideTooltip}
          type="button"
          className={classnames(
            'button--link nav__button',
            active && 'menu-item--active',
            inverse && 'button--link-inverse menu-item--inverse',
          )}
        >
          {icon && (
            <Fragment>
              <i className={`fa fa-fw fa-${icon}`} />
              {' '}
            </Fragment>
          )}
          {name}
        </button>
        {image && (
          <Tooltip
            data={tooltipData}
            parent={this.element}
            tooltipPos="right"
            active={isTooltipActive}
          />
        )}
      </li>
    );
  }
}

MenuItem.propTypes = {
  active: PropTypes.bool.isRequired,
  data: PropTypes.shape({}).isRequired,
  inverse: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

MenuItem.defaultProps = {
  inverse: false,
};

export default MenuItem;
